module.exports = __webpack_public_path__ + "img/p-xingwang.9f9df144.png";